import { render, staticRenderFns } from "./MaterialListFooterBar.vue?vue&type=template&id=39b2a543&scoped=true&lang=pug&"
import script from "./MaterialListFooterBar.vue?vue&type=script&lang=js&"
export * from "./MaterialListFooterBar.vue?vue&type=script&lang=js&"
import style0 from "./MaterialListFooterBar.vue?vue&type=style&index=0&id=39b2a543&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b2a543",
  null
  
)

export default component.exports